import React from 'react';
import { DataTable } from '@cochlear-design-system/features.dataTable';
import { Title } from '@cochlear-design-system/foundation';
import { SimpleSearch } from '../Search/SimpleSearch';
import { Error } from '../Error/Error';

export const PatientsWrapper = ({
  search,
  table,
  tableData,
  searchTerm,
  setSearchTerm,
  searchedBy,
  renderState,
  error,
  hasError = false,
  hasReachedMaxResults = false,
}) => {
  // eslint-disable-next-line no-param-reassign
  search.config.onSearch = (value) => setSearchTerm(value.q);

  const visibleColumns = table.config.columns.filter(
    (col) => !col.hidden,
  );

  const { resultsLimit } = table.config;
  const showResultsLimit =
    hasReachedMaxResults &&
    tableData?.length >= resultsLimit?.maxResults;

  const renderResultsLimitMessage = () => {
    if (!showResultsLimit || !resultsLimit) return null;

    const { additional } = resultsLimit;

    // Replace {{maxResults}} placeholder in content
    const contentText = (
      table.labels[resultsLimit.content] || ''
    ).replace('{{maxResults}}', resultsLimit.maxResults);

    // Get the text parts (text1, text2, etc.)
    const textContent = table.labels[additional?.text1] || '';

    return (
      <div
        className="ccl__results-limit"
        style={{
          display: 'flex',
          alignItems: 'flex-start',
          gap: '10px',
        }}
      >
        <img
          src={resultsLimit.pictogramSrc}
          alt="Results limit"
          style={{ width: '64px', height: 'auto', flexShrink: 0 }}
        />
        <div>
          <Title content={contentText} size="heading-4" tag="h4" />
          <div className="ccl__results-limit--additional">
            <span className="ccl__text ccl__text--x-small-body-text">
              {textContent}
            </span>
            <br />
            <button
              type="button"
              className="ccl__link-button"
              onClick={additional?.function1}
              style={{
                background: 'none',
                border: 'none',
                padding: 0,
                color: '#1a5a96',
                textDecoration: 'underline',
                cursor: 'pointer',
                font: 'inherit',
              }}
            >
              {table.labels[additional?.linkText1]}
            </button>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="ccl__dpx_patient-wrapper">
      <SimpleSearch
        config={search.config}
        labels={search.labels}
        data={search.data}
      />
      <div className="ccl__container">
        {hasError && (
          <Error
            config={error.config}
            labels={error.labels}
            data={error.data}
          />
        )}
        {!hasError && searchTerm && (
          <div
            className={`ccl__data-table--dpx ccl__data-table--searched-by-${
              searchedBy || 'name'
            }`}
          >
            <DataTable
              config={{ ...table.config, columns: visibleColumns }}
              data={tableData}
              labels={table.labels}
              stateData={{
                parameters: { searchTerm },
                renderState,
              }}
            />
            {renderResultsLimitMessage()}
          </div>
        )}
      </div>
    </div>
  );
};
